import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { capitalize } from '@modernhealth/capitalize';
import { Icon } from '../Icon/Icon';
import { ComponentTextXSmall, ComponentTextSmall, } from '../Typography/Typography';
import { IconButton } from '../IconButton/IconButton';
import * as styles from './Badge.module.scss';
const ComponentText = {
    small: {
        Text: ComponentTextXSmall,
    },
    medium: {
        Text: ComponentTextSmall,
    },
};
export var TestIDs;
(function (TestIDs) {
    TestIDs["CloseButton"] = "Badge.CloseButton.TestID";
    TestIDs["Icon"] = "Badge.Icon.TestID";
})(TestIDs || (TestIDs = {}));
const Name = 'Badge';
/**
 * Badges display numbers or status labels using semantic colors to reinforce meaning.
 */
export const Badge = ({ 
/**
 * @default 'default'
 */
variant = 'default', 
/**
 * @default 'small'
 */
size = 'small', 
/**
 * Show highlight on hover
 * @default false
 */
isHoverable, 
/**
 * Text content of Badge
 */
title, 
/**
 * @default false
 */
isDisabled = false, onDismiss, 
/**
 * Icon to render to the left of Badge title
 */
icon, 
/**
 * Aria label set on the Dismiss button
 * @default 'Dismiss'
 */
dismissAriaLabel = 'Dismiss', className, }) => {
    const containerStyle = styles[`container${capitalize(variant)}`];
    const sizeStyle = styles[`size${capitalize(size)}`];
    const hoverStyle = isHoverable && !isDisabled ? styles.containerHoverable : undefined;
    const badgeContainerStyle = [
        styles.container,
        containerStyle,
        sizeStyle,
        hoverStyle,
    ];
    const { Text } = ComponentText[size];
    const shouldShowIcon = size === 'medium' && typeof icon !== 'undefined';
    const shouldShowDismissButton = !isDisabled && size === 'medium' && typeof onDismiss !== 'undefined';
    // TODO: handle selected, and focused badge state
    return (_jsxs("div", { className: clsx(badgeContainerStyle, className), "data-component": Name, children: [shouldShowIcon && (_jsx("div", { className: styles.iconContainer, "data-testid": TestIDs.Icon, children: _jsx(Icon, { "aria-hidden": true, name: icon }) })), _jsx(Text, { children: title }), shouldShowDismissButton && (_jsx(IconButton, { icon: "x", size: "small", variant: "transparent", className: styles.dismissButton, title: dismissAriaLabel, "data-testid": TestIDs.CloseButton, onClick: () => onDismiss(title) }))] }));
};
